
import { StyleEntry } from 'Shared/backend/styleUtils';

export function layoutStyles(sizes,_text): {[name: string]: StyleEntry}
{
	return {
		'Ignore page margins': {
			explanation: 'Allows the contents to extend to the edges of the page. Useful for banner images.',

			rules: [{
				location: () => ['*'],
				ignorePageMargins: () => true
			}]
		},

		//XXX modelled off The Townie club page.  XXX USED?
		'Narrow page': {
			explanation: 'Makes page narrower. Apply at the page level. Sometimes improves the appearance of the content.',
			rules: [{
				location: () => ['^','*'],
				css: () => ({
					maxWidth: 820,
					marginLeft: 'auto',
					marginRight: 'auto',
				})
			}]
		},

		'Responsive embed': {		//XXX cf breaking down into components? eg separate out iframe part
			explanation: 'Embed uses 100% width and most the height of a desktop.',   //XXX or 'embed'?
			rules: [{
				location: () => ['*'],
				css: () => ({
					width: '100%',
					display: 'inline-block',
					overflow: 'hidden',
					paddingBottom: '56.25%',
					position: 'relative',
					marginTop: '1em',
					height: 0,

					iframe: {
						left: 0,
						top: 0,
						height: '100%',
						width: '100%',
						position: 'absolute'
					}
				})
			}]
		}
	};
}

